//---------------------------------------------------
import React, { useState, useEffect } from 'react';
import '../Styles/OnlineRecharge.css';
import onlinepayment from '../Images/onlinepayment.png';

const OnlineRecharge = () => {
  const [selectedOption, setSelectedOption] = useState('RAZORPAY');
  const [amount, setAmount] = useState('');
  const [userData, setUserData] = useState({ name: '', email: '', contact: '' });

  const handleOptionClick = (option) => {
    setSelectedOption(option);
  };

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const getUserIdFromToken = () => {
    const b2bAuthToken = localStorage.getItem('b2bAuthToken');
    if (!b2bAuthToken) {
      console.error('b2bAuthToken not found in localStorage.');
      return null;
    }

    try {
      const parsedToken = JSON.parse(b2bAuthToken);

      if (parsedToken.data && parsedToken.data._id) {
        return parsedToken.data._id;
      }

      if (parsedToken.token) {
        const tokenParts = parsedToken.token.split('.');
        if (tokenParts.length === 3) {
          const tokenPayload = tokenParts[1];
          const decodedPayload = JSON.parse(atob(tokenPayload));
          return decodedPayload.id;
        }
      }

      console.error('userId not found in token.');
      return null;
    } catch (error) {
      console.error('Error parsing token:', error);
      return null;
    }
  };

  useEffect(() => {
    const fetchUserData = async () => {
      const userId = getUserIdFromToken();
      if (!userId) {
        alert('User ID is missing. Please log in again.');
        return;
      }
    
      try { 
        // Sending POST request
        const response = await fetch(`https://b2bbackendapi.mmstourism.com/api/b2/b2b.rou.g5c6y4/a1b1c1d16/${userId}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ userId }), // Send userId in the request body
        });
    
        // Check for successful response
        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`);
        }
    
        const data = await response.json(); // Parsing the JSON response
    
        // Check if the data is successful
        if (data.status === 'SUCCESS' && data.data) {
          setUserData({
            name: data.data.fullName,
            email: data.data.emailAddress,
            contact: data.data.phoneNumber,
            // companyName: data.data.companyName,
            // whatsappNumber: data.data.whatsappNumber,
            // address: data.data.address,
            // city: data.data.city.join(', '), // Assuming the city can be an array
            // state: data.data.state.join(', '), // Assuming the state can be an array
            // country: data.data.country.join(', '), // Assuming the country can be an array
            // primaryBusiness: data.data.primaryBusiness,
            // secondaryBusiness: data.data.secondaryBusiness,
            // monthlyBusiness: data.data.monthlyBusiness,
            // secondaryMonthlyBusiness: data.data.secondaryMonthlyBusiness,
            // panFile: data.data.panFile[0], // Assuming the first PAN file link is what you need
            // gstFile: data.data.gstFile[0], // Assuming the first GST file link is what you need
            // wallet: data.data.wallet,
            // approved: data.data.approved,
          });
          console.log('Agency details:', data.data.fullName);
        } else {
          console.error('Failed to fetch user data. Status:', data.status);
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };
    
    fetchUserData();
    
    
    fetchUserData();
  },[]);    

  const handlePayment = async () => {
    if (!amount || parseFloat(amount) <= 0) {
      alert('Please enter a valid amount');
      return;
    }

    const isScriptLoaded = await loadRazorpayScript();
    if (!isScriptLoaded) {
      alert('Failed to load Razorpay SDK. Please try again later.');
      return;
    }

    try {
      const userId = getUserIdFromToken();
      if (!userId) {
        alert('User ID is missing. Please log in again.');
        return;
      }
//http://localhost:6009
      const response = await fetch(`https://b2bbackendapi.mmstourism.com/api/b2/b2b.rou.g5c6y4/m4n3o2p16/${userId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          amount: parseFloat(amount) , // Convert to paise
        }),
      });

      const { success, order } = await response.json();
      if (!success) {
        alert('Failed to create order. Please try again.');
        return;
      }

      const options = {
        key: 'rzp_live_fyXllJiRnEXPAg',
        amount: order.amount,
        currency: order.currency,
        name: userData.name,
        description: 'Test Transaction',
        order_id: order.id,
        method: {
          upi: true,
          netbanking: true,
          card: false, // Disable cards
          wallet: false, // Disable wallets 
        },
        handler: async function (response) {
          const verificationResponse = await fetch('https://b2bbackendapi.mmstourism.com/api/b2/b2b.rou.g5c6y4/v4w3x2y16', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              order_id: response.razorpay_order_id,
              payment_id: response.razorpay_payment_id,
              signature: response.razorpay_signature,
            }),
          });

          const result = await verificationResponse.json();
          if (result.success) {
            alert('Payment successful and wallet updated!');
          } else {
            alert('Payment verification failed!');
          }
        },
        prefill: {
          name: userData.name,
          email: userData.email,
          contact: userData.contact,
        },
        theme: {
          color: '#528FF0',
        },
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();
    } catch (error) {
      console.error('Error during payment:', error);
      alert('An error occurred while processing the payment.');
    }
  };

  return (
    <div className="online-container">
      <div className="header-section">
        <span
          id="RAZORPAY"
          className={`option ${selectedOption === 'RAZORPAY' ? 'selected' : ''}`}
          onClick={() => handleOptionClick('RAZORPAY')}
        >
          RAZORPAY
        </span>
      </div>
      <div className="pay-amt">
        <div className="payment-icons">
          <span>Recharge your Account Using</span>
          <img src={onlinepayment} alt="Payment Options" className="payment-logo" />
        </div>

        <div className="form-section">
          <div className="form-online-group">
            <label>Amount</label>
            <input
              type="number"
              placeholder="0.00"
              value={amount}
                onChange={(e) => setAmount(e.target.value)}
            />
          </div>
          <div className="form-online-group">
             <label>Payment Option</label>
             <select>
                 <option>Select Payment Option</option>
                 <option>UPI</option>
                 <option>NET BANKING</option>
               </select>
             </div>
          <button onClick={handlePayment} style={{ padding: '10px 20px', fontSize: '16px' }}>
            Pay Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default OnlineRecharge;
//---------------------------------------------------
// import React, { useState, useEffect } from 'react';
// import '../Styles/OnlineRecharge.css';
// import { useNavigate } from 'react-router-dom';

// const OnlineRecharge = () => {
//   const [selectedOption, setSelectedOption] = useState('RAZORPAY');
//   const [amount, setAmount] = useState('');
//   const [userData, setUserData] = useState({ name: '', email: '', contact: '' });

//   const navigate = useNavigate();

//   const handleOptionClick = (option) => {
//     setSelectedOption(option);
//   };


//   const getUserIdFromToken = () => {
//     const b2bAuthToken = localStorage.getItem('b2bAuthToken');
//     if (!b2bAuthToken) {
//       console.error('b2bAuthToken not found in localStorage.');
//       return null;
//     }

//     try {
//       const parsedToken = JSON.parse(b2bAuthToken);

//       if (parsedToken.data && parsedToken.data._id) {
//         return parsedToken.data._id;
//       }

//       if (parsedToken.token) {
//         const tokenParts = parsedToken.token.split('.');
//         if (tokenParts.length === 3) {
//           const tokenPayload = tokenParts[1];
//           const decodedPayload = JSON.parse(atob(tokenPayload));
//           return decodedPayload.id;
//         }
//       }

//       console.error('userId not found in token.');
//       return null;
//     } catch (error) {
//       console.error('Error parsing token:', error);
//       return null;
//     }
//   };

//   useEffect(() => {
//     const fetchUserData = async () => {
//       const userId = getUserIdFromToken();
//       if (!userId) {
//         alert('User ID is missing. Please log in again.');
//         return;
//       }
    
//       try { 
//         // Sending POST request
//         const response = await fetch(`https://b2bbackendapi.mmstourism.com/api/b2/b2b.rou.g5c6y4/a1b1c1d16/${userId}`, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({ userId }), // Send userId in the request body
//         });
    
//         // Check for successful response
//         if (!response.ok) {
//           throw new Error(`Request failed with status ${response.status}`);
//         }
    
//         const data = await response.json(); // Parsing the JSON response
    
//         // Check if the data is successful
//         if (data.status === 'SUCCESS' && data.data) {
//           setUserData({
//             name: data.data.fullName,
//             email: data.data.emailAddress,
//             contact: data.data.phoneNumber,
                     
//           });
//           console.log('Agency details:', data.data.fullName);
//         } else {
//           console.error('Failed to fetch user data. Status:', data.status);
//         }
//       } catch (error) {
//         console.error('Error fetching user data:', error);
//       }
//     };
    
//     fetchUserData();
    
    
//     fetchUserData();
//   },[]);    

  
//   return (
//     <div className="online-container">
//       <div className="header-section">
//        <h2>MMSTOURISM</h2>
//       </div>
//       <div className="pay-amt">
       

//         <div className="form-section">
//           <div className="form-online-group">
//             <label style={{ padding: '10px 20px', fontSize: '20px' }}>Add Balance In Your Wallet</label>
//               </div>
         
//           {/* <button style={{ padding: '10px 20px', fontSize: '16px' }}>
//             Pay Now
//           </button> */}
//    <button
//   style={{ padding: '10px 20px', fontSize: '16px' }}
//   onClick={() => {
//       // Navigate to QR code page
//     navigate('/qrcode');
//   }}
// >
//   Pay Now
// </button>


//         </div>
//       </div>
//     </div>
//   );
// };

// export default OnlineRecharge;
// //----------------------both 
// // import React, { useState, useEffect } from 'react';
// // import '../Styles/OnlineRecharge.css';
// // import { useNavigate } from 'react-router-dom';

// // const OnlineRecharge = () => {
// //   const [amount, setAmount] = useState('');
// //   const [userData, setUserData] = useState({ name: '', email: '', contact: '' });
// //   const navigate = useNavigate();

// //   const getUserIdFromToken = () => {
// //     const b2bAuthToken = localStorage.getItem('b2bAuthToken');
// //     if (!b2bAuthToken) return null;

// //     try {
// //       const parsedToken = JSON.parse(b2bAuthToken);
// //       if (parsedToken.data && parsedToken.data._id) return parsedToken.data._id;

// //       if (parsedToken.token) {
// //         const tokenParts = parsedToken.token.split('.');
// //         if (tokenParts.length === 3) {
// //           const tokenPayload = tokenParts[1];
// //           const decodedPayload = JSON.parse(atob(tokenPayload));
// //           return decodedPayload.id;
// //         }
// //       }
// //       return null;
// //     } catch (error) {
// //       console.error('Token parsing error:', error);
// //       return null;
// //     }
// //   };

// //   useEffect(() => {
// //     const fetchUserData = async () => {
// //       const userId = getUserIdFromToken();
// //       if (!userId) return alert('Please login again.');

// //       try {
// //         const response = await fetch(`https://b2bbackendapi.mmstourism.com/api/b2/b2b.rou.g5c6y4/a1b1c1d16/${userId}`, {
// //           method: 'POST',
// //           headers: { 'Content-Type': 'application/json' },
// //           body: JSON.stringify({ userId }),
// //         });

// //         const data = await response.json();
// //         if (data.status === 'SUCCESS' && data.data) {
// //           setUserData({
// //             name: data.data.fullName,
// //             email: data.data.emailAddress,
// //             contact: data.data.phoneNumber,
// //           });
// //         }
// //       } catch (error) {
// //         console.error('Fetch user failed:', error);
// //       }
// //     };

// //     fetchUserData();
// //   }, []);

// //   const handlePayNow = () => {
// //     const userId = getUserIdFromToken();
// //     if (!userId || !amount || parseFloat(amount) <= 0) {
// //       return alert('Please enter a valid amount.');
// //     }

// //     // Navigate to QR page with amount + userId
// //     navigate('/qrcode', { state: { amount, userId } });
// //   };

// //   return (
// //     <div className="online-container">
// //       <div className="header-section">
// //         <h2>MMSTOURISM</h2>
// //       </div>

// //       <div className="pay-amt">
// //         <div className="form-section">
// //           <div className="form-online-group">
// //             <label style={{ fontSize: '20px' }}>Add Balance In Your Wallet</label>
// //           </div>

// //           <div className="form-online-group">
// //             <input
// //               type="number"
// //               placeholder="Enter amount"
// //               value={amount}
// //               onChange={(e) => setAmount(e.target.value)}
// //             />
// //           </div>

// //           <button style={{ padding: '10px 20px', fontSize: '16px' }} onClick={handlePayNow}>
// //             Pay Now
// //           </button>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default OnlineRecharge;
